import { render, staticRenderFns } from "./CreateRbuEditionDialog.vue?vue&type=template&id=5a05e5e4"
import script from "./CreateRbuEditionDialog.vue?vue&type=script&lang=js"
export * from "./CreateRbuEditionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports